import Choices from 'choices.js';

export default function () {
  document.querySelectorAll('.js-choice').forEach(setup);
}

function setup(element) {
  try {
    const instance = new Choices(element, {
      placeholderValue: '',
      removeItemButton: true,
      allowHTML: true,
    });

    if (element.value) {
      instance.containerInner.element.classList.add('choices__inner_is-selected');
    }
  } catch (e) {
    console.error('Error setting up choice:', e);
  }
}
